<div class="d-flex flex-column justfiy-content-center align-items-center modal-container">
  <div class="modal-body">
    <div class="product-info" [innerHTML]="product.name"></div>
    <div class="mt-2">{{ 'has been added to your ' + mode | translate }}</div>
  </div>
  <div class="modal-footer d-flex justify-content-center gap-3">
    <button class="btn btn-primary btn-view" (click)="onConfirm()">
      {{ (mode === 'cart' ? 'View cart' : 'View wishlist') | translate }}
    </button>
    <button class="btn btn-outline-primary" (click)="activeModal.close()">
      {{ 'Continue shopping' | translate }}
    </button>
  </div>
</div>
